import React from 'react';
import {Form, Input, Select, Button, Alert} from 'antd';
import {Link} from 'react-router';
import {UUID_NULL} from '../constants/defaultValues'
import img from '../style/imgs/banner.png';
import {APP_TITLE} from '../constants/configValues'
import auth from '../api/auth'
const FormItem = Form.Item;
const Option = Select.Option;

const formItemLayout = {
  labelCol: {
    span: 8
  },
  wrapperCol: {
    span: 16
  }
}

const tailFormItemLayout = {
  wrapperCol: {
    xs: {
      span: 24,
      offset: 0
    },
    sm: {
      span: 17,
      offset: 7
    }
  }
}

class RegisterForm extends React.Component {
  state = {
    emailHasFeddback: false,
    userNameHasFeddback: false,
    phoneHasFeddback: false,
    confirmDirty: false,
    systemID: UUID_NULL
  }

  componentDidMount() {
    const {systems, form} = this.props
    if (systems.length === 1) {
      form.setFieldsValue({SystemID: systems[0].ID});
    }
  }

  handleConfirmBlur = (e) => {
    const value = e.target.value;
    this.setState({
      confirmDirty: this.state.confirmDirty || !!value
    });
  }

  checkPassword = (rule, value, callback) => {
    const form = this.props.form;
    if (value && value !== form.getFieldValue('password')) {
      callback('Nhập lại mật khẩu không khớp!');
    } else {
      callback();
    }
  }

  checkConfirm = (rule, value, callback) => {
    const form = this.props.form;
    if (value && this.state.confirmDirty) {
      form.validateFields(['confirmPassword'], {force: true});
    }
    callback();
  }

  checkHasEmail = (rule, value, callback) => {
    const form = this.props.form;
    if (value && value !== "") {
      auth.hasUser(value).then((res) => {
        if (res) {
          this.setState({emailHasFeddback: false})
          callback('Email đã sử dụng!');
          return
        } else {
          this.setState({emailHasFeddback: true})
          callback()
        }
      })
    } else {
      callback()
    }
  }

  checkHasUser = (rule, value, callback) => {
    const form = this.props.form;
    if (value && value !== "") {
      auth.hasUser(value).then((res) => {
        if (res) {
          callback('Tài khoản đã sử dụng!');
          return
        } else {
          this.setState({userNameHasFeddback: true})
          callback()
        }
      })
    } else {
      callback()
    }
  }

  checkHasPhone = (rule, value, callback) => {
    const form = this.props.form;
    if (value && value !== "") {
      auth.hasUser(value).then((res) => {
        if (res) {
          callback('Số điện thoại đã sử dụng!');
          return
        } else {
          this.setState({phoneHasFeddback: true})
          callback()
        }
      })
    } else {
      callback()
    }
  }

  render() {
    const {fetching, systems, error, onSubmit, form} = this.props;
    const {getFieldDecorator} = form;
    const {systemID, emailHasFeddback, userNameHasFeddback, phoneHasFeddback} = this.state
    const errorElement = error
      ? <Alert type="error" message={error} banner="banner"/>
      : <div className="error"></div>;
    return (<div className="login">
      <div className="login-form">
        <img src={img} alt="banner" className="banner"/>
        <div className="title">{APP_TITLE}</div>
        {errorElement}
        <Form onSubmit={onSubmit} layout="horizontal">
          <FormItem label="Hệ thống" {...formItemLayout}>
            {
              getFieldDecorator('systemID', {
                rules: [
                  {
                    required: true,
                    message: 'Phải chọn hệ thống!'
                  }
                ]
              })(<Select placeholder="Chọn hệ thống">
                {
                  systems.map((sys) => {
                    return <Option key={sys.ID} value={sys.ID.toString()}>{sys.Name}</Option>
                  })
                }
              </Select>)
            }
          </FormItem>
          <FormItem label="Họ tên" {...formItemLayout}>
            {
              getFieldDecorator('fullName', {
                rules: [
                  {
                    required: true,
                    message: 'Phải nhập họ tên!'
                  }
                ]
              })(<Input placeholder="họ và tên"/>)
            }
          </FormItem>
          <FormItem label="E-mail" {...formItemLayout} hasFeedback={emailHasFeddback}>
            {
              getFieldDecorator('email', {
                rules: [
                  {
                    required: true,
                    message: 'Phải nhập email!'
                  }, {
                    type: 'email',
                    message: 'Email không hợp lệ!'
                  }, {
                    validator: this.checkHasEmail
                  }
                ]
              })(<Input placeholder="email"/>)
            }
          </FormItem>
          <FormItem label="Tài khoản" {...formItemLayout} hasFeedback={userNameHasFeddback}>
            {
              getFieldDecorator('userName', {
                rules: [
                  {
                    required: true,
                    message: 'Phải nhập tài khoản!'
                  }, {
                    validator: this.checkHasUser
                  }
                ]
              })(<Input placeholder="tài khoản"/>)
            }
          </FormItem>
          <FormItem label="Số đt" {...formItemLayout} hasFeedback={phoneHasFeddback}>
            {
              getFieldDecorator('phone', {
                rules: [
                  {
                    required: true,
                    message: 'Phải nhập số điện thoại!'
                  }, {
                    pattern: /^(84|0)(1\d{9}|9\d{8})$/,
                    message: "Số điện thoại không hợp lệ!"
                  }, {
                    validator: this.checkHasPhone
                  }
                ]
              })(<Input placeholder="số điện thoại"/>)
            }
          </FormItem>
          <FormItem label="Mật khẩu" {...formItemLayout} hasFeedback={true}>
            {
              getFieldDecorator('password', {
                rules: [
                  {
                    required: true,
                    message: 'Phải nhập mật khẩu!'
                  }, {
                    validator: this.checkConfirm
                  }
                ]
              })(<Input type="password" placeholder='••••••••••'/>)
            }
          </FormItem>
          <FormItem label="Mật khẩu lần 2" {...formItemLayout} hasFeedback={true}>
            {
              getFieldDecorator('confirmPassword', {
                rules: [
                  {
                    required: true,
                    message: 'Phải nhập lại mật khẩu!'
                  }, {
                    validator: this.checkPassword
                  }
                ]
              })(<Input type="password" placeholder='••••••••••' onBlur={this.handleConfirmBlur}/>)
            }
          </FormItem>
          <FormItem {...tailFormItemLayout}>
            <Button disabled={fetching} type="primary" htmlType="submit" className="btn-login">
              ĐĂNG KÝ
            </Button>
            <Link to={'/login'}>Đăng nhập</Link>
          </FormItem>
        </Form>
      </div>
    </div>);
  }
}

export default Form.create()(RegisterForm)



// WEBPACK FOOTER //
// ./src/components/RegisterForm.js